module.exports = __webpack_public_path__ + "static/join-group-footer-b1a6fed453c2c0d58957bb713280f2be.png";